import { render, staticRenderFns } from "./RegionalRanking.vue?vue&type=template&id=31544df6&scoped=true&"
import script from "./RegionalRanking.vue?vue&type=script&lang=js&"
export * from "./RegionalRanking.vue?vue&type=script&lang=js&"
import style0 from "./RegionalRanking.vue?vue&type=style&index=0&id=31544df6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31544df6",
  null
  
)

export default component.exports